module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/info-drawer-bullet-work-together-52956f57.svg";